import { listenToStartSearchTrackEvent as initTrackWidgetModal } from '../../components/TrackingWidget/TrackWidgetModal.vue';
import { factory as initMobileHeaderMenu } from '../../components/MobileHeaderMenu/MobileHeaderMenu.vue';
import { factory as personalAccountButtonFactory } from '../../components/PersonalAccountChoiceModal/PersonalAccountButton.vue';

export default function initErrorPage() {
  initTrackWidgetModal();

  initMobileHeaderMenu({
    subpage: true,
  });

  personalAccountButtonFactory({
    classModifier: 'button-accounts_header-desktop',
    restorePopupMode: 'desktop',
  });
}
